import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  createErrorToasterMessage,
  createSuccessToasterMessage,
} from 'data/ui/actions'
import { makesMutations } from 'data/graphql'
import { deleteTemplate as deleteTemplateQuery } from 'remote/notes'

const providesDeleteTemplate = compose(
  connect(
    null,
    {
      createErrorToasterMessage,
      createSuccessToasterMessage,
      noteTemplateDeleted(template) {
        return {
          type: 'noteTemplateDeleted',
          payload: template,
        }
      },
    }
  ),
  makesMutations({
    query: deleteTemplateQuery,
    mutationPropName: 'deleteTemplate',
    getOnResultFromProps: ({
      createSuccessToasterMessage,
      noteTemplateDeleted,
    }) => ({ result }) => {
      noteTemplateDeleted(result.data.deleteTemplate)
      createSuccessToasterMessage({ title: 'Template successfully deleted' })
    },
    getOnErrorFromProps: ({ createErrorToasterMessage }) => ({ error }) => {
      createErrorToasterMessage({ title: error.message })
    },
  })
)

export default providesDeleteTemplate
